import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';

import type { SaveSsoConnectionRequest, SsoConnection } from './type';

type ProviderType = SsoConnection['providerType'];

export const getSsoProviders = async () => {
  const res = await apiClient.GET('/v2/settings/sso/providers');
  return getDataOrThrowApiError(res);
};

export const getSsoConnections = async () => {
  const res = await apiClient.GET('/v2/settings/sso/connections');
  return getDataOrThrowApiError(res);
};

export const saveSsoConnection = async (
  providerType: string,
  body: SaveSsoConnectionRequest,
) => {
  const res = await apiClient.PUT(
    '/v2/settings/sso/connections/{providerType}',
    {
      params: { path: { providerType: providerType as ProviderType } },
      body,
    },
  );
  return getDataOrThrowApiError(res);
};

export const deleteSsoConnection = async (providerType: string) => {
  const res = await apiClient.DELETE(
    '/v2/settings/sso/connections/{providerType}',
    {
      params: { path: { providerType: providerType as ProviderType } },
    },
  );
  return getDataOrThrowApiError(res);
};
